import QuestionInputSelectMultiEquivalents from "./QuestionInputSelectMultiEquivalents";
import GelButton from "../gel/GelButton";
import GelHackButton from "../gel/GelHackButton";
import common from "../../common";

export default class QuestionInputSelectMultiVisualEquivalents extends QuestionInputSelectMultiEquivalents{
    constructor(question, view) {
        super(question, view);
    }

    deselectOption(option) {
        this._selected.alpha = 1;
        //this._selected._currentNormalTexture = P3.assets.texture("ui_drop_in_area");
        this._selected.onMouseOut({});
        this._selected = null;
    }

    createOptionButtons(options) {
        this._buttonsContainer = new PIXI.Container();
        this.addChild(this._buttonsContainer);

        // minimum font size
        this._fontSize = this.calculateFontSize(options);

        for (let i = 0; i < options.length; ++i) {
            const button = this.createOptionButton(options[i]);
            button.index = i;
            button.position.set(this._spacing * i - (this._spacing * (options.length - 1)) * 0.5, 0);
            button.tabIndex = GelButton.TAB_INDEX_LEVEL_1 + i;
            button.signals.down.add(this.onOptionButtonDown, this);
            button.signals.up.add(this.onOptionButtonUp, this);
            button.signals.click.add(this.onOptionButtonClick, this);

            const buttonBack = new PIXI.Sprite(P3.assets.texture("ui_drop_in_answerbox"));
            buttonBack.anchor.set(0.5);
            buttonBack.position.set(button.x, button.y);
            //this._buttonsContainer.addChildAt(buttonBack, 0);
            this._buttonsContainer.addChild(button);
            this._buttons.push(button);
        }
    }

    createOptionButton(value) {
        const button = !PIXI.utils.isMobile.any ?
            GelHackButton.create(PIXI.Texture.EMPTY) :
            P3.Button.create(PIXI.Texture.EMPTY);

        button.value = value;
        button.animate = false;
        button.animateIcon = false;
        button.tint = common.config.debug && button.value === this._question.answer ? 0x00AA00 : 0xFFFFFF;

        const str = button.value.toString();
        const fontSize = str.length < 5 ? 40 : 20;

        button.image = new PIXI.Sprite(P3.assets.texture(value.texture));
        button.image.anchor.set(0.5);
        button.image.scale.set(0.5);
        button.animation.addChild(button.image);
        // button.label = new PIXI.Text(str, {
        //     fontSize: fontSize, fontFamily: "Arial", fontWeight: "bold", fill: 0x0});
        // button.label.position.set(0, 0);
        // button.label.anchor.set(0.5, 0.5);
        // button.label.resolution = 2;
        //button.animation.addChild(button.label);
        return button;
    }
}